import React from 'react';
import SectionCard from './SectionCard';

const CustomRecipientsSection = ({ submission, isDark }) => {
    if (submission.recipient_source !== 'non-strata' || !submission.customRecipients || submission.customRecipients.length === 0) {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Recipients ({submission.customRecipients.length})</p>
            <div className="flex flex-col gap-[16px]">
                {Array.from({ length: Math.ceil(submission.customRecipients.length / 3) }, (_, rowIndex) => (
                    <div key={rowIndex} className="flex flex-row gap-[16px] flex-wrap">
                        {submission.customRecipients.slice(rowIndex * 3, (rowIndex + 1) * 3).map((recipient, colIndex) => {
                            const index = rowIndex * 3 + colIndex;
                            return (
                                <div
                                    key={index}
                                    className={`box-border flex flex-col p-[12px] gap-[8px] w-[232px] rounded-[8px] border-solid border-[1px] transition-colors duration-200 ${
                                        isDark ? 'bg-[#161515] border-[#292929]' : 'bg-[#F5F5F5] border-[#D9D9D9]'
                                    }`}
                                >
                                    <span className={`font-semibold text-[14px] leading-[18px] transition-colors duration-200 ${
                                        isDark ? 'text-white' : 'text-[#072837]'
                                    }`}>
                                        {recipient.name}
                                    </span>
                                    <span className={`font-normal text-[14px] leading-[18px] transition-colors duration-200 ${
                                        isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
                                    }`}>
                                        {recipient.postal}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </SectionCard>
    );
};

export default CustomRecipientsSection;
